<p-dialog header="Added List" [(visible)]="displayAddedList" (onHide)="closeDialog()" [modal]="true"
    [responsive]="true" [closable]="true" [style]="{width: '60vw'}">
    <div class="card">
        <p-table [value]="addedWidgets">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>List Type</th>
                    <th>Module Name</th>
                    <th>Channel Name</th>
                    <th>Module Column</th>
                    <th>
                        {{ savedSearchId ? 'Saved Search Column' : 'Workbook Column'}}
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-widgetDetails let-rowIndex="rowIndex">
                <tr>
                    <td>{{ widgetDetails.widgetName }}</td>
                    <td>{{ widgetDetails.widgetType }}</td>
                    <td>{{ widgetDetails.moduleName }}</td>
                    <td>{{ widgetDetails.channelName }}</td>
                    <td>{{ widgetDetails.associationFieldName }}</td>
                    <td>{{ widgetDetails.referenceFieldName }}</td>
                    <td class="action">
                        <span class="btnBars" pTooltip="Edit" tooltipPosition="top" (click)="openEditList(widgetDetails)">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars" pTooltip="Delete" tooltipPosition="top" (click)="removeAddedList(widgetDetails)">
                            <i class="pi pi-trash"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<app-add-to-list *ngIf="displayAddToList"
    [selectedWidget]="selectedWidget"
    [displayAddToList]="displayAddToList"
    [savedSearchId]="savedSearchId"
    [savedSearchModuleId]="savedSearchModuleId"
    [savedSearchTemplateId]="savedSearchTemplateId"
    [selectedWorkbook] = "selectedWorkbook"
    (listAdded)="getAddedWidgets()"
    (dialogClosed)="cancelToList()">
</app-add-to-list>
